module.exports = __webpack_public_path__ + "img/image42.debaa894.png";